import { WebStorageStateStore } from "oidc-client-ts";

const oidcConfig = {
  authority: process.env.REACT_APP_KEYCLOAK_URL + "/realms/" + process.env.REACT_APP_KEYCLOAK_REALM,
  client_id: process.env.REACT_APP_KEYCLOAK_CLIENT_ID,
  
  // Matches Keycloak "Valid redirect URIs"
  redirect_uri: window.location.origin + "/auth/callback",
  
  // Matches Keycloak "Valid post logout redirect URIs"
  post_logout_redirect_uri: window.location.origin + "/",
  
  response_type: "code",
  scope: "openid profile email offline_access",
  automaticSilentRenew: true,
  accessTokenExpiringNotificationTimeInSeconds: 60,
  loadUserInfo: true,
  // monitorSession uses an iframe that Keycloak blocks with X-Frame-Options.
  // With offline_access scope, silent renewal uses the refresh token instead.
  monitorSession: false,
  
  // Persistence across tabs
  userStore: new WebStorageStateStore({ store: window.localStorage }),

  // Force include client_id in logout to avoid "Invalid parameter: redirect_uri"
  // and handle post-login cleanup
  onSigninCallback: (_user) => {
    window.history.replaceState({}, document.title, window.location.pathname);
    window.location.href = "/";
  },

  // Helper for components to call logout correctly
  metadataSeed: {
    end_session_endpoint: `${process.env.REACT_APP_KEYCLOAK_URL}/realms/${process.env.REACT_APP_KEYCLOAK_REALM}/protocol/openid-connect/logout`
  }
};

export default oidcConfig;